<template>
  <div>
    <!-- APP BAR -->
    <v-app-bar app color="primary" dark>
      <slot class="bar-content" name="bar-content">
        <div @click="navigateBack()" v-if="shouldShowBackArrow">
          <v-icon class="mdi-24px">mdi-arrow-left-bold-circle-outline</v-icon> Back
        </div>
        <v-spacer></v-spacer>
        <div class="actual-title">Orbit Treasury</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </slot>
    </v-app-bar>
    <!-- CONTENT -->
    <v-main height="100%">
      <slot class="default" name="default">Treasury Content</slot>
    </v-main>
    <!-- BOTTOM NAV -->
    <v-bottom-navigation color="primary" grow light app fixed>
      <v-btn @click="goToAccounts">
        <span>Accounts</span>
        <v-icon>mdi-bank</v-icon>
      </v-btn>
      <v-btn @click="goToPayments">
        <span>Payments</span>
        <v-icon>mdi-cash-multiple</v-icon>
      </v-btn>
      <v-btn @click="goToCashPosition">
        <span>Cash Position</span>
        <v-icon>mdi-chart-line</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "cash-layout",
  mounted() {},
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "Login" });
    },
    navigateBack() {
      this.$router.go(-1);
    },
    goToAccounts() {
      this.$router.push({ name: "CashBalances" });
    },
    goToPayments() {
      this.$router.push({ name: "Payments" });
    },
    goToCashPosition() {
      this.$router.push({ name: "CashPosition" });
    },
  },
  computed: {
    shouldShowBackArrow() {
      //WE WANT TO AVOID THESE PAGES
      return (
        ["CashBalances", "Payments", "CashPosition"].indexOf(
          this.$store.getters["activity/getCurrentPageName"]
        ) < 0
      );
    },
  },
};
</script>

<style lang="scss">
.actual-title {
  position: absolute;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  text-align: center;
  z-index: -1;
}

.v-bottom-navigation {
  border-top: 1px solid #aaa;
  background-color: #ddd;
}

.bar-content {
  border: 2px solid red !important;
}
</style>
